<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12"> <!-- revisit later using xl="12" etc !-->
          <transition name="slide">
          <b-card :header="caption">
            <b-table :busy="isLoading" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="userList" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
              <template slot="id" slot-scope="data">
                <strong>{{data.item.id}}</strong>
              </template>
              <template slot="name" slot-scope="data">
                <strong>{{data.item.name}}</strong>
              </template>
              <template slot="status" slot-scope="data">
                <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="getRowCount(userList)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card>
          </transition>
        </b-col>
      </b-row>

      </div><!--animated-fadein -->
        <b-modal title="Add User" v-model="myModal" @ok="saveUser" effect="fade/zoom" ok-text="Save Changes" cancel-text="Cancel">
        <div slot="modal-header" class="modal-header">
          <h5 class="modal-title"><i class="fa fa-plus"></i> Add User</h5>
        </div>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-block">
              <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
                <div class="form-group">
                  <label for="firstName">First Name</label>
                  <input type="text" class="form-control" id="firstName" placeholder="First Name" v-model="formData.firstName">
                </div>
                <div class="form-group">
                  <label for="lastName">Last Name</label>
                  <input type="text" class="form-control" id="lastName" placeholder="Last Name" v-model="formData.lastName">
                </div>
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input type="email" class="form-control" id="email" placeholder="E-mail" v-model="formData.email">
                </div>
                <div class="form-group">
                  <label for="phoneNumber">Phone Number</label>
                  <input type="text" class="form-control" id="phoneNumber" placeholder="Enter Phone Number" v-model="formData.phoneNumber">
                </div>
                <div class="form-group">
                  <label for="roleName">User Role</label>
                  <select id="roleName" class="form-control" v-model="formData.roleName" placeholder="Select User Role">
                    <option value="Admin">Admin</option>
                    <option value="User" selected>User</option>
                  </select>
                </div>
                <div class="row">
                </div><!--/.row-->
              </form>
            </div>
          </div>
        </div><!--/.col-->
      </b-modal>
    </div><!--wrapper-->
</template>

<script>
import { tokenMixin } from '@/mixins/tokenMixin'
import modal from 'bootstrap-vue'

export default {
  name: 'AdminUserList',
  mixins: [tokenMixin],
  components: {
  },
  props: {
  caption: {
    type: String,
    default: '<i class="fa fa-align-justify"></i> Users'
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: true
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
  data () {
    return {
      userList: [],
      fields: [
        {key: 'firstName'},
        {key: 'lastName'},
        {key: 'email'},
        {key: 'avatarLocation'},
        {key: 'status'}
      ],
      isLoading: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      myModal: false,
      element: '',
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        roleName: ''
      }
    }
  },

  methods: {
    addUser (e) {
      e.preventDefault();
      this.myModal = true;
      console.log('Add User');
    },
    saveUser () {
      this.myModal = false;
      var config = {
        headers: {'Authorization': 'bearer ' + this.$localStorage.get('token')}
      };
      this.axios.put(process.env.VUE_APP_API_BASE + 'auth/admin/user', this.formData, config)
        .then(function (response) {
          //console.log(response);
          if(response.data.result == 1 )
          {
              console.log("success");
          }
          else {
            console.log(response.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatDate (dateIn) {
      if (dateIn === null || dateIn === '0001-01-01T00:00:00')
      {
        return ''
      }
      else {
        var dateOut = new Date(dateIn);
        return dateOut.toLocaleDateString();
      }
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
      : status === 'Inactive' ? 'secondary'
        : status === 'Pending' ? 'warning'
          : status === 'Banned' ? 'danger' : 'primary'

    },
    getRowCount (items) {
      return items.length
    },
    userLink (id) {
      return `users/${id.toString()}`
    },
    rowClicked (item) {
      const userLink = this.userLink(item.id)
      this.$router.push({path: userLink})
    }
  },
  mounted: function () {
    //console.log('env=' + process.env.API_BASE);
    //from the mixin
    if (this.checkForToken())
    {
      var config = {
        headers: {'Authorization': 'bearer ' + this.$localStorage.get('token')}
      };
      this.axios.get(process.env.VUE_APP_API_BASE + 'user/allusers', config).then(response => {
        this.isLoading = false
        return response
      })
      .then(res => {
        if (res.status === 200)
        {
          this.userList = res.data;
        }
      })
      .catch(error => {
        console.log(error.response)
      });
    }
  }
}
</script>
